import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink }        from 'react-router-dom';
import DV                 from 'ts-data-validator';

import { useCommon } from '../../../../providers/common';

const MenuItem = function(props) {
  const { t } = useTranslation();

  const {
          className,
          expand,
          handleExpand,
          item,
          onClick,
          parentIds = [],
        } = props;

  const common = useCommon();

  const ids    = React.useMemo(() => {
    if (!item?.menuId) {
      return parentIds;
    }

    return [...parentIds, item.menuId];
  }, [item?.menuId, parentIds]);
  const isOpen = React.useMemo(() => {
    if (!item?.menuId) {
      return false;
    }

    return expand.includes(item.menuId);
  }, [expand, item?.menuId]);

  const isEmpty = React.useCallback((item) => {
    if (DV.isNotEmptyArray(item?.pages)) {
      return !item.pages
        .map(isEmpty)
        .includes(false);
    }

    return !item?.url;
  }, []);

  if (isEmpty(item) || item?.label === t('admin_menu.discount')) {
    return null;
  }

  return (
    <li
      className={className}
      data-key={props['data-key']}
    >
      {DV.isNotEmptyArray(item.pages)
        ? (
          <span className={classNames({ open: isOpen })}>
          <span onClick={() => handleExpand(isOpen ? parentIds : ids)}>
            {item.label} <span className="ic-arrow-bottom" />
          </span>
          <ul className={'sub-menu'}>
            {item.pages.map((subItem, subItemIndex) => {
              if (common.pages.some((page) => {
                return page.template === 'dealer' && page.urlKey === subItem.url;
              })) {
                return null;
              }

              return (
                <MenuItem
                  {...props}
                  item={subItem}
                  key={subItemIndex}
                  onClick={onClick}
                  parentIds={ids}
                />
              );
            })}
          </ul>
        </span>
        )
        : /^http/g.test(item.url)
          ? (
            <a
              href={item.url}
              rel={'noopener nofollow noindex noreferrer'}
              target={'_blank'}
            >{item.label}</a>
          )
          : (
            <NavLink
              onClick={() => {
                onClick(item);
              }}
              to={`/${item.url}`}
            >{item.label}</NavLink>
          )
      }
    </li>
  );
};

export default MenuItem;
